import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireLink} from '../umpire-link';

export interface UmpireComponentFooter
  extends UmpireComponent<UmpireComponentTypeEnum.PAGE_FOOTER> {
  links: UmpireLink[];
  facebook_url: string;
  twitter_url: string;
  instagram_url: string;
  youtube_url: string;
  apple_app_store_url: string;
  google_play_url: string;
  galaxy_store_url: string;
}
